export var cmToFeetInches = function (cm) {
    var num = Number(cm);
    if (!Number.isFinite(num) || num <= 0) {
        return { feet: '', inches: '' };
    }
    var totalInches = num / 2.54;
    var feet = Math.floor(totalInches / 12);
    var remainingInches = Math.round(totalInches % 12);
    return {
        feet: feet.toString(),
        inches: remainingInches.toString(),
    };
};
export var feetInchesToCm = function (feet, inches) {
    return Math.round((feet * 12 + inches) * 2.54);
};
